import { useCallback } from "react";
import { useToaster } from "@design-system/ToastMessages/useToaster";

export const STRIPE_SETUP_ERROR_TOAST =
    "Couldn't open Stripe setup, please try again.";

/**
 * Shared "mint an Account Link, then leave the app for Stripe-hosted KYC"
 * sequence used by every Express connect / finish-setup entry point. Awaits the
 * mint call, hard-navigates to the returned hosted URL, and toasts a single
 * shared error message on failure.
 */
export function useStripeExpressRedirect(): (
    mint: () => Promise<{ url: string }>,
) => Promise<void> {
    const { toast } = useToaster();
    return useCallback(
        async (mint: () => Promise<{ url: string }>): Promise<void> => {
            try {
                const { url } = await mint();
                window.location.assign(url);
            } catch {
                toast(STRIPE_SETUP_ERROR_TOAST);
            }
        },
        [toast],
    );
}
